import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-images-catalogues',
  templateUrl: './images-catalogues.component.html',
  styleUrls: ['./images-catalogues.component.scss'],
})
export class ImagesCataloguesComponent implements OnInit{
  @Input() banner: string = '';
  @Input() image: string = '';
  @Output() uploadedFiles = new EventEmitter();

  cards = []

  constructor() {
    
  }

  ngOnInit(): void {
    
    this.cards = [
      {
        title: 'Imágen de banner',
        type: 'banner',
        description: 'Ésta foto se mostrará como imágen de fondo dentro del catálogo',
        url: this.banner
      },
      {
        title: 'Imágen miniatura',
        type: 'image',
        description: 'Es la imágen de vista previa que se mostrará por fuera del catálogo',
        url: this.image
      }
    ]

    
    
  }

  emitFiles(ev){
    this.uploadedFiles.emit(ev);
  }

}
